module.exports = __webpack_public_path__ + "img/txt_arena.0542d0f3.png";